import { useTranslation } from "react-i18next";
import { useSplitScreenContext } from "./split-screen-context";
import { cn } from "@/utils/cn";

export const SplitScreenToggle = () => {
  const { t } = useTranslation(["common"]);
  const { showSplitScreen, startSplitScreen, stopSplitScreen, isSplitScreenAvailable } = useSplitScreenContext();

  const handleToggle = () => {
    if (showSplitScreen) stopSplitScreen();
    else startSplitScreen();
  };

  if (!isSplitScreenAvailable) return null;
  return (
    <button
      title={t("common:a11y.start_split_screen")}
      onClick={handleToggle}
      className={cn(
        "flex size-9 shrink-0 items-center justify-center rounded-sxs hover:bg-primary/10",
        showSplitScreen && "text-primary bg-primary/10",
      )}
    >
      <img
        src="/icons/interface-icons/shared/icon-3d-grid.png"
        alt={t("common:chrome.split_screen")}
        draggable={false}
        className="size-7 object-contain"
      />
    </button>
  );
};
